import React, {
  Fragment,
  useState,
  useEffect,
  createRef,
  useRef,
  useContext,
  useCallback,
} from "react";
import { useForm, Controller } from "react-hook-form";
import { Btn, H5, H3, H4, H6, LI, P, UL } from "../../AbstractElements";
import { Col, Container, Label, Row, CardBody, Card, Table } from "reactstrap";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import moment from "moment";
import Select from "react-select";
import cloneDeep from "lodash/cloneDeep";
import { useNavigate, useLocation, Link } from "react-router-dom";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { SiteContext } from "../../App";
import { aocontext } from "../../App";
import { PlusCircle } from "react-feather";
import { toast } from "react-toastify";
import { Typeahead } from "react-bootstrap-typeahead";
import SiteData from "../../Data/Sites/index";
import CategoryData from "../../Data/Category/index";
import { limit } from "../../Config/Config";
import { generateClient } from "aws-amplify/api";
const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});
var base64 = require("base-64");

const DeleteTaskMRT = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [sites, setSites] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const LoginUserGroup = localStorage.getItem("groups");
  const LoginUserDetails = JSON.parse(localStorage.getItem("userDetails"));
  const [siteDetails, setSiteDetails] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [filtertask, settaskFilter] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [categoryDetails, setCategoryDetails] = useState([]);
  const [siteError, setSiteError] = useState(false);
  const [catassets, setCatAssets] = useState([]);
  const [selectedItemsOpen, setSelectedItemsOpen] = useState([]);
  const [isAllSelectedOpen, setIsAllSelectedOpen] = useState(false);
  let itemss = [];
  const [isCheckboxCheckedOpen, setIsCheckboxCheckedOpen] = useState([]);
  const { selectedSiteGlobal, handleSiteChange } = useContext(SiteContext);
  const { selectedAssetOwnerGlobal, handleAssetOwner } = useContext(aocontext);

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
    e,
    ...form
  } = useForm();

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    if (localStorage.getItem("site") === null && sites.length === 0) {
      LoginUserGroup === "site_owner" || LoginUserGroup === "spao"
        ? fetchSiteDetailsAO()
        : fetchSiteDetailsSPSU(LoginUserDetails.id);
    } else {
      let activeSites = JSON.parse(base64.decode(localStorage.getItem("site")));
      setSites(activeSites.filter((item) => item.status === "Active"));
      setSiteDetails(activeSites.filter((item) => item.status === "Active"));
    }
    if (
      localStorage.getItem("category") === null &&
      categoryDetails.length === 0
    ) {
      fetchCategory();
    } else {
      setCategoryDetails(CategoryData.getCategoryData());
    }
  }, [selectedSiteGlobal, selectedAssetOwnerGlobal]);

  async function fetchCategory() {
    try {
      let nextToken = "";
      let categories = [];
      const dataDetails = await client.graphql({
        query: queries.listCategories,
        authMode: "API_KEY",
        variables: {
          limit: 200000,
        },
      });
      if (dataDetails.data.listCategories.items.length > 0) {
        let assetDatas = dataDetails.data.listCategories.items;
        nextToken = dataDetails.data.listCategories.nextToken;
        if (dataDetails.data.listCategories.items.length > 0) {
          categories.push(assetDatas);
        }
        while (nextToken !== null) {
          const dataDetailss = await client.graphql({
            query: queries.listCategories,
            variables: {
              limit: 200000,
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          if (dataDetailss.data.listCategories.items.length > 0) {
            nextToken = dataDetailss.data.listCategories.nextToken;
            if (dataDetailss.data.listCategories.items.length > 0) {
              categories.push(dataDetailss.data.listCategories.items);
            }
          }
        }
        console.log(categories);
        if (categories.length > 0) {
          const mergeCategories = categories.flat(1);
          setCategoryDetails(mergeCategories);
          CategoryData.setCategoryData(mergeCategories);
          localStorage.setItem(
            "category",
            base64.encode(JSON.stringify(mergeCategories)),
          );
        }
      }
    } catch (error) {
      console.log(error);
      setCategoryDetails([]);
      CategoryData.setCategoryData([]);
    }
  }

  async function fetchSiteDetailsAO() {
    try {
      let nextToken = "";
      let sites = [];
      const result = await client.graphql({
        query: queries.siteDetailsByAssetownerID,
        variables: {
          assetownerID: LoginUserDetails.id,
          limit: 200000,
        },
        authMode: "API_KEY",
      });
      if (result.data.siteDetailsByAssetownerID.items.length > 0) {
        let assetDatas = result.data.siteDetailsByAssetownerID.items;
        nextToken = result.data.siteDetailsByAssetownerID.nextToken;
        if (result.data.siteDetailsByAssetownerID.items.length > 0) {
          sites.push(assetDatas);
        }
        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.siteDetailsByAssetownerID,
            variables: {
              assetownerID: LoginUserDetails.id,
              limit: 200000,
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          if (results.data.siteDetailsByAssetownerID.items.length > 0) {
            nextToken = results.data.siteDetailsByAssetownerID.nextToken;
            if (results.data.siteDetailsByAssetownerID.items.length > 0) {
              sites.push(results.data.siteDetailsByAssetownerID.items);
            }
          } else {
            nextToken = null;
          }
        }
        console.log(sites);
        if (sites.length > 0) {
          const mergeSites = sites.flat(1);
          setSites(mergeSites.filter((item) => item.status === "Active"));
          SiteData.setSiteData(mergeSites);
          localStorage.setItem(
            "site",
            base64.encode(JSON.stringify(mergeSites)),
          );
        } else {
          setSites([]);
          setIsLoading(false);
        }
      } else {
        setSites([]);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setSites([]);
      setIsLoading(false);
    }
  }

  //--sites for sp/su
  async function fetchSiteDetailsSPSU(assetOwnerId) {
    try {
      let nextToken = "";
      let linkedSites = [];
      const result = await client.graphql({
        query: queries.linkUsersAndSitesByUserdetailsID,
        authMode: "API_KEY",
        variables: {
          userdetailsID: assetOwnerId,
          filter: {
            status: {
              eq: "Active",
            },
          },
          limit: limit,
        },
      });
      if (result.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
        let assetDatas = result.data.linkUsersAndSitesByUserdetailsID.items;
        nextToken = result.data.linkUsersAndSitesByUserdetailsID.nextToken;
        if (result.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
          linkedSites.push(assetDatas);
        }
        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.linkUsersAndSitesByUserdetailsID,
            authMode: "API_KEY",
            variables: {
              userdetailsID: assetOwnerId,
              filter: {
                status: {
                  eq: "Active",
                },
              },
              limit: limit,
              nextToken: nextToken,
            },
          });
          if (results.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
            nextToken = results.data.linkUsersAndSitesByUserdetailsID.nextToken;
            if (
              results.data.linkUsersAndSitesByUserdetailsID.items.length > 0
            ) {
              linkedSites.push(
                results.data.linkUsersAndSitesByUserdetailsID.items,
              );
            }
          } else {
            nextToken = null;
          }
        }
        console.log(linkedSites);
        if (linkedSites.length > 0) {
          const mergeSites = linkedSites.flat(1);
          let sitesforUsers = [];
          const promises = mergeSites.map(async (item) => {
            return await client.graphql({
              query: queries.getSiteDetails,
              variables: {
                id: item.sitedetailsID,
              },
              authMode: "API_KEY",
            });
          });
          Promise.all(promises).then((sitesData) => {
            sitesData.forEach((sites) => {
              if (sites.data.getSiteDetails !== null) {
                sitesforUsers.push(sites.data.getSiteDetails);
              }
            });
            setSites(sitesforUsers.filter((item) => item.status === "Active"));
            setSiteDetails(
              sitesforUsers.filter((item) => item.status === "Active"),
            );
            localStorage.setItem(
              "site",
              base64.encode(JSON.stringify(sitesforUsers)),
            );
            //SiteData.setSiteData(sitesforUsers);
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  const setSite = (site) => {
    console.log(site);
    if (site.length > 0) {
      setSiteError(false);
      console.log(site[0].id);
      setSiteId(site[0].id);
    } else {
      setSiteError(true);
    }
  };

  useEffect(() => {
    fetchTasks(siteId);
  }, [siteId]);

  useEffect(() => {
    //statuschange();
  }, []);

  async function statuschange() {
    const result = await client.graphql({
      query: queries.assetsByAssettemplateSiteIDAndAssetNum,
      variables: {
        assettemplateSiteID:
          "7f9a2e64-a929-4250-86c5-1bcc5134a20e_6f9a0f07-ea16-42fd-8a6f-06760b8a6c54",
        limit: limit,
        filter: {
          status: {
            eq: "delete",
          },
        },
      },
      authMode: "API_KEY",
    });
    console.log("result", result);
    const assetDta = result.data.assetsByAssettemplateSiteIDAndAssetNum.items;
    console.log(assetDta);
  }

  async function fetchTasks(site) {
    console.log(site);
    try {
      let nextToken = "";
      let assets = [];
      //---fetching tasks
      const result = await client.graphql({
        query: queries.tasksBySitedetailsID,
        variables: {
          sitedetailsID: site,
          filter: {
            status: {
              eq: "Active",
            },
            taskStatus: {
              ne: "Completed",
            },
          },
          limit: limit,
        },
        authMode: "API_KEY",
      });
      console.log(result);
      if (result.data.tasksBySitedetailsID.items.length > 0) {
        let assetDatas = result.data.tasksBySitedetailsID.items;
        nextToken = result.data.tasksBySitedetailsID.nextToken;
        console.log(
          "first token count",
          result.data.tasksBySitedetailsID.items.length,
        );
        console.log("nextToken 1", nextToken);
        if (result.data.tasksBySitedetailsID.items.length > 0) {
          assets.push(assetDatas);
        }
        while (nextToken !== null) {
          const results = await client.graphql({
            query: queries.tasksBySitedetailsID,
            variables: {
              sitedetailsID: site,
              filter: {
                status: {
                  eq: "Active",
                },
                taskStatus: {
                  ne: "Completed",
                },
              },
              limit: limit,
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          if (results.data.tasksBySitedetailsID.items.length > 0) {
            nextToken = results.data.tasksBySitedetailsID.nextToken;
            console.log("nextToken", nextToken);
            console.log(results.data.tasksBySitedetailsID.items.length);
            if (results.data.tasksBySitedetailsID.items.length > 0) {
              assets.push(results.data.tasksBySitedetailsID.items);
            }
          } else {
            nextToken = null;
          }
        }
        console.log(assets);
        if (assets.length > 0) {
          const mergeTasks = assets.flat(1);
          console.log(mergeTasks);
          setTasks(mergeTasks);
          settaskFilter(mergeTasks);
        }
      } else {
        setTasks([]);
        settaskFilter([]);
        toast.error("No Tasks Created for the selected Site!..", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  function getSiteName(id) {
    const siteName = siteDetails.find((item) => item.id === id);
    return siteName
      ? siteName.siteName + " " + "(" + siteName.unitNumber + ")"
      : "";
  }

  const handleCheckboxChangeOpen = (event, item) => {
    console.log(item);
    console.log(itemss);

    const isChecked = event.target.checked;
    if (item === "selectAll") {
      setIsAllSelectedOpen(isChecked);

      if (isChecked) {
        const allItems = tasks.map((item) => item);
        setSelectedItemsOpen(allItems);
        itemss = allItems;
      } else {
        setSelectedItemsOpen([]);
        itemss = [];
      }
    } else {
      if (isChecked) {
        setIsCheckboxCheckedOpen(item);
        setSelectedItemsOpen((prevSelectedItems) => [
          ...prevSelectedItems,
          item,
        ]);
        itemss = [...itemss, item];
      } else {
        setIsCheckboxCheckedOpen(null);
        setSelectedItemsOpen((prevSelectedItems) =>
          prevSelectedItems.filter((selectedItem) => selectedItem !== item),
        );
        itemss = itemss.filter((selectedItem) => selectedItem !== item);
      }

      // Check if all items are selected
      console.log(itemss);
      const allSelected = tasks.every((item) => itemss.includes(item));
      console.log(allSelected);
      setIsAllSelectedOpen(allSelected);
    }
  };

  const handleDeleteTasks = () => {
    console.log("Deleting selected tasks:", selectedItemsOpen);

    const allAssetIds = selectedItemsOpen.flatMap((task) => {
      try {
        const links = JSON.parse(task.taskCompletionLink || "[]");

        return links.flatMap((link) => {
          if (task.taskType === "Test") {
            return link.assets || [];
          } else if (
            task.taskType === "Repair" ||
            task.taskType === "Replace"
          ) {
            return link.assetsTest || [];
          } else {
            return [];
          }
        });
      } catch (e) {
        console.error("Invalid JSON in taskCompletionLink for task:", task.id);
        return [];
      }
    });
    console.log(allAssetIds);
    const uniqueAssetIds = [...new Set(allAssetIds)];
    const deletePromises = uniqueAssetIds.map(async (item, i) => {
      await sleep(Math.random() * i * 17);
      console.log("Asset ID:", item);

      // Step 1: Get the current asset to retrieve _version
      const assetData = await client.graphql({
        query: queries.getAssets,
        variables: { id: item },
        authMode: "API_KEY",
      });
      console.log(assetData);
      const asset = assetData.data.getAssets;
      if (!asset) {
        console.log("Asset not found:", item);
        return;
      }

      // Step 2: Use _version in the update
      const deleteResult = await client.graphql({
        query: mutations.updateAssets,
        variables: {
          input: {
            id: item,
            addedToTask: "",
            _version: asset._version, // Required for update to succeed
          },
        },
        authMode: "API_KEY",
      });

      console.log("Delete result:", deleteResult);
    });

    let counter = 0;
    const deletePromisesTasks = selectedItemsOpen.map(async (item, i) => {
      await sleep(Math.random() * i * 17);

      const deleteResult = await client.graphql({
        query: mutations.updateTask,
        variables: {
          limit: limit,
          input: {
            id: item.id,
            status: "Inactive",
          },
        },
        authMode: "API_KEY",
      });
      //console.log(deleteResult);

      if (deleteResult) {
        counter = counter + 1;

        if (counter === selectedItemsOpen.length) {
          toast.success(
            "Tasks for selected site were successfully made status Inactive.",
            {
              position: toast.POSITION.TOP_CENTER,
            },
          );
        }
      }
    });
    //---
    const remainingTasks = tasks.filter(
      (task) => !selectedItemsOpen.includes(task),
    );
    setTasks(remainingTasks);
    setSelectedItemsOpen([]);
    setIsAllSelectedOpen(false);
    setSiteId([]);
  };

  const getCategoryID = (task) => {
    try {
      const parsed = JSON.parse(task.taskCompletionLink);
      const categoryId = parsed?.[0]?.category;
      const category = categoryDetails.find((c) => c.id === categoryId);
      return category ? category.categoryName : "Unknown Category";
    } catch (e) {
      return "Invalid Link";
    }
  };

  const optionsCategory = [
    { value: "", label: "Select Category" },
    ...categoryDetails.map((item) => ({
      value: item.id,
      label: item.categoryName,
    })),
  ];

  //--- category dropdown
  const handleCategory = (event) => {
    const selectedCategoryId = event.value;
    setCatAssets(selectedCategoryId);

    if (selectedCategoryId === "") {
      setTasks(filtertask);
      return;
    }

    const filteredTasks = filtertask.filter((task) => {
      try {
        const link = JSON.parse(task.taskCompletionLink);
        const categoryInTask = link?.[0]?.category;
        return categoryInTask === selectedCategoryId;
      } catch (error) {
        console.error(
          "Invalid taskCompletionLink JSON:",
          task.taskCompletionLink,
        );
        return false;
      }
    });
    console.log(filteredTasks);
    setTasks(filteredTasks);
  };

  const renderList = (
    <Fragment>
      <Container fluid={true}>
        <br></br>
        <Col md="12" className="project-list">
          <Card className="custom-card">
            <Row>
              <H4>Tasks List</H4>
            </Row>
            <Row>
              <Col md="5 mb-3">
                {/* <Label>Site</Label> */}
                <Typeahead
                  id="rendering-example"
                  multiple={false}
                  options={siteDetails}
                  labelKey={(siteDetails) =>
                    `${siteDetails.siteName} ,(${
                      siteDetails.unitNumber ? siteDetails.unitNumber : ""
                    })`
                  }
                  placeholder="Choose Site"
                  onChange={(d) => setSite(d)}
                />
                {siteError ? <span>{"Selecting Site is required"}</span> : ""}
              </Col>
              <Col md="5 mb-3">
                {/* <Label>Category</Label> */}
                <Select
                  options={optionsCategory}
                  isSearchable={true}
                  placeholder="Select Category"
                  onChange={handleCategory}
                  menuPlacement="auto"
                  menuPosition="fixed"
                />
              </Col>
              {/* </Row>
                        <Row>
                            <Col md="10 mb-3"></Col> */}
              <Col md="2 mb-3">
                <Btn
                  attrBtn={{
                    color: "primary",
                    disabled: selectedItemsOpen.length === 0,
                    onClick: handleDeleteTasks,
                  }}
                >
                  Delete Task
                </Btn>
              </Col>
            </Row>
            <CardBody>
              <div className="card-block row">
                <Col sm="12" lg="12" xl="12">
                  <br></br>
                  <br></br>
                  <div className="table-responsive">
                    <Table className="table-striped table-de">
                      <thead className="custom-table-head">
                        <tr>
                          <th scope="col">
                            <input
                              type="checkbox"
                              checked={isAllSelectedOpen}
                              onChange={(event) =>
                                handleCheckboxChangeOpen(event, "selectAll")
                              }
                            />
                          </th>
                          <th>Added On</th>
                          <th>Task Type</th>
                          <th>Site</th>
                          <th>Task Status</th>
                          <th>Category</th>
                          <th>Task Assigned Date</th>
                          <th>Due Date</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      {tasks.length > 0 ? (
                        <tbody className="trhover">
                          {tasks
                            .sort(
                              (a, b) =>
                                new Date(b.createdAt) - new Date(a.createdAt),
                            )
                            .map((item, i) => (
                              <tr key={i}>
                                <td>
                                  <input
                                    type="checkbox"
                                    name="testPass"
                                    checked={selectedItemsOpen.includes(item)}
                                    onChange={(event) =>
                                      handleCheckboxChangeOpen(event, item)
                                    }
                                  />
                                </td>
                                <td>
                                  {moment(item.createdAt).format("DD/MM/YYYY")}
                                </td>
                                <td>{item.taskType}</td>
                                <td>{getSiteName(item.sitedetailsID)}</td>
                                <td>{item.taskStatus}</td>
                                <td>{getCategoryID(item)}</td>
                                <td>
                                  {moment(item.assignedDate).format(
                                    "DD/MM/YYYY",
                                  )}
                                </td>
                                <td>
                                  {item.dueDate !== null
                                    ? moment(item.dueDate).format("DD/MM/YYYY")
                                    : "-"}
                                </td>
                                <td>{item.status}</td>
                              </tr>
                            ))}
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td colSpan="12" className="text-center">
                              No Tasks available.
                            </td>
                          </tr>
                        </tbody>
                      )}
                    </Table>
                  </div>
                </Col>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Container>
    </Fragment>
  );
  return (
    <div>
      {renderList}
      {errorMessage && <div className="error">{errorMessage}</div>}
    </div>
  );
};

export default DeleteTaskMRT;
